import { useHistory } from "react-router-dom";
import { useCurrentSpaceContext } from "@circle-react/contexts";
import {
  canManageSpace,
  userIsAdminOrModeratorOfSpace,
} from "@circle-react/helpers/spaceHelpers";
import {
  removeQueryParam,
  updateQueryParam,
} from "@circle-react/helpers/urlHelpers";
import { useRouterQueryParams } from "@circle-react/hooks/useRouterQueryParams";

const PREVIEW_KEY = "preview";

export const usePreviewAsStudent = () => {
  const history = useHistory();
  const queryParams = useRouterQueryParams();

  const { data: space } = useCurrentSpaceContext();
  const isAdmin = userIsAdminOrModeratorOfSpace(space);

  const canMemberManageSpace = canManageSpace(space);

  const isLessonPreview = isAdmin;
  /* Admin Summary is on the same route, so adding a query param */
  const isCoursePreview =
    canMemberManageSpace && queryParams[PREVIEW_KEY] === "true";

  const onPreviewCourse = (params = {}) => {
    history.push({
      ...params,
      search: updateQueryParam(PREVIEW_KEY, true),
    });
  };

  const onStopCoursePreview = (params = {}) => {
    history.push({
      ...params,
      search: removeQueryParam(PREVIEW_KEY),
    });
  };

  return {
    isCoursePreview,
    isLessonPreview,
    onPreviewCourse,
    onStopCoursePreview,
  };
};
